
const headers = [
    {
      label: 'วันเวลาไกล่เกลี่ยผู้ร้อง',
      field: 'customerMediate',
      tdClass: '',
    },
    {
      label: 'วันเวลาไกล่เกลี่ยผู้ถูกร้อง',
      field: 'companyMediate',
      tdClass: '',
    },
    {
      label: 'ชื่อชุดอนุกรรมการ',
      field: 'groupName',      
    },
    {
      label: 'สถานะการอนุมัติจดหมายเชิญ',
      field: 'committeeStatus',      
    },
    {
      label: 'Action',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers